<template>
  <!-- Some por inteiro quando o SSO nao esta configurado ou o script nao carregou:
       um divisor "ou" sobrando acima de nada e pior do que nao ter o botao. -->
  <div v-if="state !== 'unavailable'" class="google-signin mt-2">
    <div class="google-divider">
      <span>ou</span>
    </div>

    <!-- O Google renderiza o botao dentro deste container (iframe proprio). -->
    <div ref="button" class="google-button-slot" :class="{ 'is-busy': busy }"></div>

    <small v-if="state === 'loading'" class="text-muted d-block text-center mt-1">Carregando…</small>
    <small v-if="busy" class="text-muted d-block text-center mt-1">Entrando com o Google…</small>
  </div>
</template>

<script>
import {
  isGoogleSignInEnabled,
  renderGoogleButton,
  releaseGoogleButton
} from '@/services/googleIdentity'

/**
 * Botao "Continuar com o Google" do backoffice.
 *
 * Gemeo do componente do marketplace — o markup e do Google (diretriz de marca), so
 * a moldura muda para o visual do backoffice. O componente apenas emite o ID token;
 * o que fazer com ele e decisao da tela.
 */
export default {
  name: 'GoogleSignInButton',
  props: {
    // 'continue_with' | 'signin_with' | 'signup_with'
    text: {
      type: String,
      default: 'continue_with'
    },
    busy: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      state: isGoogleSignInEnabled() ? 'loading' : 'unavailable'
    }
  },
  mounted() {
    if (this.state === 'unavailable') return

    // A MESMA referencia precisa chegar ao release, senao soltariamos o handler de
    // outra tela que ja tenha assumido o botao.
    this.handler = (idToken) => this.$emit('credential', idToken)

    renderGoogleButton(this.$refs.button, this.handler, { text: this.text })
      .then(() => {
        this.state = 'ready'
      })
      .catch((error) => {
        // Adblock e bloqueio de rede sao o caso comum. O login por senha continua
        // na tela, entao a falha e degradacao, nao erro.
        console.warn('[Google] botao indisponivel:', error.message)
        this.state = 'unavailable'
      })
  },
  beforeDestroy() {
    if (this.handler) releaseGoogleButton(this.handler)
  }
}
</script>

<style lang="scss" scoped>
/**
 * Divisor em flex, com duas linhas ladeando o texto — e nao um texto com fundo por
 * cima de uma linha. O backoffice tem tema claro e escuro; qualquer cor de fundo
 * chumbada no rotulo apareceria como um retangulo errado em um dos dois.
 */
.google-divider {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: rgba(34, 41, 47, 0.12);
  }

  span {
    font-size: 0.8125rem;
    color: #b9b9c3;
  }
}

.google-button-slot {
  display: flex;
  justify-content: center;
  min-height: 44px;

  &.is-busy {
    opacity: 0.6;
    pointer-events: none;
  }
}
</style>
